// extracted by mini-css-extract-plugin
module.exports = {"container":"index-container-pZBa2","title":"index-title-1N_ml","content":"index-content-3cuVe"};